import { Link } from 'react-router-dom';

export default function Footer() {
  const socialLinks = [
    { icon: 'ri-instagram-line', url: 'https://instagram.com/nexuflowdynamics', label: '@nexuflowdynamics' },
    { icon: 'ri-instagram-line', url: 'https://instagram.com/hrcarrasquel', label: '@hrcarrasquel' },
    { icon: 'ri-facebook-line', url: 'https://facebook.com', label: 'Programa Educación Vial' },
    { icon: 'ri-tiktok-line', url: 'https://tiktok.com/@hrcarrasquel', label: '@hrcarrasquel' },
    { icon: 'ri-telegram-line', url: 'https://t.me', label: 'QuantFin Signals' },
    { icon: 'ri-telegram-line', url: 'https://t.me', label: 'AULA MOTORIZADA' }
  ];

  const services = [
    'Agentes IA',
    'Desarrollo Web',
    'Apps Móviles',
    'Educación Vial',
    'Trading Signals',
    'Automatización'
  ];

  return (
    <footer className="relative bg-gradient-to-b from-gray-900 via-purple-900/20 to-black border-t border-cyan-500/20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/b3587ce69abb46ff06ed1a4e56cdaeaf.jpg')] opacity-5 bg-cover bg-center"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-400 via-purple-500 to-pink-500 flex items-center justify-center">
                <i className="ri-flow-chart text-2xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
                  NEXUS FLOW
                </span>
                <span className="text-xs text-gray-400">DYNAMICS</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Conectando realidades a través de un ecosistema 3D integral de IA, desarrollo y educación.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Servicios</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a href="#services" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center group">
                    <i className="ri-arrow-right-s-line text-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Redes Sociales</h3>
            <ul className="space-y-3">
              {socialLinks.slice(0, 4).map((social, index) => (
                <li key={index}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center group"
                  >
                    <i className={`${social.icon} mr-2 text-lg`}></i>
                    {social.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Comunidades</h3>
            <ul className="space-y-3">
              {socialLinks.slice(4).map((social, index) => (
                <li key={index}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center group"
                  >
                    <i className={`${social.icon} mr-2 text-lg`}></i>
                    {social.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a
                href="#contact"
                className="inline-block px-6 py-2.5 rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 text-white text-sm font-medium hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap"
              >
                Contáctanos
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © 2024 Nexus Flow Dynamics. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Privacidad
              </a>
              <a href="#" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Términos
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
